import { Icon } from "@chakra-ui/react"

export const CheckmarkIcon = (props: any) => (
  <Icon id="Group_1163" data-name="Group 1163" xmlns="http://www.w3.org/2000/svg" width="22.895" height="16.815" viewBox="0 0 22.895 16.815" {...props}>
    <g id="Group_1162" data-name="Group 1162">
      <path id="Path_563" data-name="Path 563" d="M1827.263,762.658a1.143,1.143,0,0,0-1.617,0l-13.716,13.716-5.271-5.271a1.145,1.145,0,0,0-1.619,1.619l6.081,6.081a1.145,1.145,0,0,0,1.619,0l14.524-14.526A1.146,1.146,0,0,0,1827.263,762.658Z" transform="translate(-1804.703 -762.323)" fill="#06bcc1"/>
    </g>
  </Icon>
);
